/**
 * Route for `order-recovery-workflow`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { OrderRecoveryWorkflowPage } from "../features/order-recovery-workflow/OrderRecoveryWorkflowPage";

export const orderRecoveryWorkflowRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/order-recovery-workflow",
	component: OrderRecoveryWorkflowPage,
});

export default orderRecoveryWorkflowRoute;
